import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback } from "react";

import { type AwsSsoLoginRequest, type AwsSsoStatus, awsApi } from "../../internal/_interop/aws";
import { $awsSsoStatus, $selectedAwsProfile, $selectedAwsRegion } from "../../internal/aws";

export const useAwsSso = () => {
	const statusLoadable = useAtomValue(loadable($awsSsoStatus));
	const selectedProfileLoadable = useAtomValue(loadable($selectedAwsProfile));
	const selectedRegionLoadable = useAtomValue(loadable($selectedAwsRegion));

	const refreshStatus = useSetAtom($awsSsoStatus);

	const status: AwsSsoStatus | null =
		statusLoadable.state === "hasData" ? statusLoadable.data : null;

	const login = useCallback(
		async (request: AwsSsoLoginRequest) => {
			const api = awsApi();
			const result = await api.ssoLogin(request);
			refreshStatus();
			return result;
		},
		[refreshStatus]
	);

	const logout = useCallback(async () => {
		const api = awsApi();
		await api.ssoLogout();
		refreshStatus();
	}, [refreshStatus]);

	return {
		status,
		selectedProfile:
			selectedProfileLoadable.state === "hasData" ? selectedProfileLoadable.data : null,
		selectedRegion:
			selectedRegionLoadable.state === "hasData" ? selectedRegionLoadable.data : null,
		isLoading: statusLoadable.state === "loading",
		login,
		logout,
		refreshStatus,
	};
};
